import { render, staticRenderFns } from "./WinsDetailsModal.vue?vue&type=template&id=1c85f328"
import script from "./WinsDetailsModal.vue?vue&type=script&lang=js"
export * from "./WinsDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./WinsDetailsModal.vue?vue&type=style&index=0&id=1c85f328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports